import React from 'react';
import {createRoot} from 'react-dom/client';
import {DotSnackbarProvider, DotThemeProvider} from '@digital-ai/dot-components';
import {Provider} from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import store from './stores/store';
import {AuthenticationProvider} from './providers/AuthenticationProvider';
import routes from './routes';
import GlobalStyles from './global/global.styles';

const root = createRoot(document.getElementById('app'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router>
                <DotThemeProvider>
                    <GlobalStyles/>
                    <DotSnackbarProvider>
                        <AuthenticationProvider>
                            {routes}
                        </AuthenticationProvider>
                    </DotSnackbarProvider>
                </DotThemeProvider>
            </Router>
        </Provider>
    </React.StrictMode>
);
